module.exports = __webpack_public_path__ + "img/bg_vocabulary_02.a6bc15f2.jpg";